export default __webpack_public_path__ + "static/media/profil.cd6f058c.png";